export enum SourceTypes {
  CMS = "CMS",
  PIM = "PIM"
}
